import * as React from "react";
import DefinitionList from "components/common/DefinitionList";
import ChipsCell from "components/common/ChipsCell";
import { TacticTechnique } from "security-app/components/SecurityEvents/Alerts/ColumnRenderers";
const stripPrefix = (value) => value.replace(/^attack\./i, "");
const isTechnique = (value) => /^t\d+/i.test(value);
const EventTacticsTechniquesDetailRow = ({ entity }) => {
  var _a, _b;
  const seen = /* @__PURE__ */ new Set();
  const techniques = [];
  const add = (raw) => {
    if (typeof raw !== "string" || !raw) return;
    const stripped = stripPrefix(raw);
    if (!isTechnique(stripped)) return;
    const key = stripped.toUpperCase();
    if (seen.has(key)) return;
    seen.add(key);
    techniques.push(stripped);
  };
  ((_a = entity.tactics_techniques) != null ? _a : []).forEach(add);
  Object.entries((_b = entity.fields) != null ? _b : {}).filter(([k]) => k.startsWith("sigma_rule_tag_")).forEach(([, value]) => add(value));
  if (!techniques.length) return null;
  return /* @__PURE__ */ React.createElement(DefinitionList, null, /* @__PURE__ */ React.createElement("dt", null, "Tactics/Techniques"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement(ChipsCell, { items: techniques, truncate: false, renderItemContent: (id) => /* @__PURE__ */ React.createElement(TacticTechnique, { value: id }) })));
};
export default EventTacticsTechniquesDetailRow;
